import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TextEditor from "components/TextEditor/TextEditor";
import { toast } from "react-hot-toast";
import { Input, Select } from "components/Form";
import { Button } from "components/Button/Button";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import { EditorState } from "draft-js";
import useStepper from "hooks/useStepper";
import {
  alphabetsArray,
  countArray,
  objectTypeChecker,
  rawToHtmlConverter,
} from "utils";
import { addDailyQuiz } from "services/dailyQuiz/dailyQuizController";
import ReactDatePicker from "react-datepicker";
import moment from "moment";

const COUNTS = {
  1: "One",
  2: "Two",
  3: "Three",
  4: "Four",
  5: "Five",
  6: "Six",
  7: "Seven",
  8: "Eight",
  9: "Nine",
  10: "Ten",
};

const ALPHABETS = {
  1: "A",
  2: "B",
  3: "C",
  4: "D",
  5: "E",
  6: "F",
  7: "G",
  8: "H",
  9: "I",
  10: "J",
  11: "K",
  12: "L",
  13: "M",
  14: "N",
  15: "O",
  16: "P",
  17: "Q",
  18: "R",
  19: "S",
  20: "T",
  21: "U",
  22: "V",
  23: "W",
  24: "X",
  25: "Y",
  26: "Z",
};

const AddQuiz = () => {
  const navigate = useNavigate();

  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [startDate, setStartDate] = useState("");
  const [allQuestions] = useState([1, 2, 3, 4, 5]);
  const [totalOption] = useState(4);

  // stepper hooks
  const { activeStep, Stepper, handleNext, handleBack, allStepsCompleted } =
    useStepper(allQuestions.map((lan) => `Question ${lan}`));

  const [data, setData] = useState({
    question0: EditorState.createEmpty(),
    optionOne0: "",
    optionTwo0: "",
    optionThree0: "",
    optionFour0: "",
    correctOption0: "",
    answer0: EditorState.createEmpty(),
  });

  const [errorField, setErrorField] = useState({
    question0: "",
    optionOne0: "",
    optionTwo0: "",
    optionThree0: "",
    optionFour0: "",
    correctOption0: "",
    answer0: "",
  });

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    const question = objectTypeChecker(data[`question${activeStep}`])
      ? rawToHtmlConverter(data[`question${activeStep}`].getCurrentContent())
          .length
      : 8;

    const answer = objectTypeChecker(data[`answer${activeStep}`])
      ? rawToHtmlConverter(data[`answer${activeStep}`].getCurrentContent())
          .length
      : 8;

    if (question === 8) {
      errorField[`question${activeStep}`] = "Please Enter Question";
      formIsValid = false;
    }
    if (answer === 8) {
      errorField[`answer${activeStep}`] = "Please Enter Answer";
      formIsValid = false;
    }

    // dynamic option validation
    countArray(totalOption).forEach((num) => {
      if (!data[`option${COUNTS[num]}${activeStep}`]) {
        errorField[
          `option${COUNTS[num]}${activeStep}`
        ] = `Please Enter Option ${num}`;
        formIsValid = false;
      }
    });

    if (!data[`correctOption${activeStep}`]) {
      errorField[`correctOption${activeStep}`] = "Please Select Correct Option";
      formIsValid = false;
    }

    if (!startDate) {
      errorField[`startDate`] = "Please Select Quiz Date";
      formIsValid = false;
    }

    setErrorField(errorField);
    return formIsValid;
  };

  //*********************Submit Question Handler********************************** */
  const submitQuestionHandler = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    try {
      const allQuestionsArr = [];

      // design question arr
      allQuestions.forEach((lan, i) => {
        // check options are blank or not
        const validationStatus = countArray(totalOption).every((num) => {
          return !data[`option${COUNTS[num]}${i}`];
        });

        if (
          (validationStatus && objectTypeChecker(data[`question${i}`])
            ? rawToHtmlConverter(data[`question${i}`].getCurrentContent())
            : "",
          objectTypeChecker(data[`answer${i}`])
            ? rawToHtmlConverter(data[`answer${i}`].getCurrentContent())
            : "")
        ) {
          let designObj = {
            correctOption: data[`correctOption${i}`],
            question: objectTypeChecker(data[`question${i}`])
              ? rawToHtmlConverter(data[`question${i}`].getCurrentContent())
              : "",
            description: objectTypeChecker(data[`answer${i}`])
              ? rawToHtmlConverter(data[`answer${i}`].getCurrentContent())
              : "",
          };

          countArray(totalOption).forEach((num) => {
            Object.assign(designObj, {
              [`option${ALPHABETS[num]}`]: data[`option${COUNTS[num]}${i}`],
            });
          });

          allQuestionsArr.push(designObj);
        }
      });

      const res = await addDailyQuiz({
        quizDate: moment(startDate).format("YYYY-MM-DD"),
        questions: allQuestionsArr,
        action: "add",
      });
      if (res.code === 200) {
        toast.success(res.message);
        setSubmitLoading(false);
        navigate(`/daily-quiz`);
      } else {
        toast.error(res.message);
        setSubmitLoading(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
      setSubmitLoading(false);
    }
  };

  // this function used for validation data checking
  const submitHandler = (e) => {
    e.preventDefault();
    if (activeStep + 1 === allQuestions.length) {
      if (handleValidation()) {
        submitQuestionHandler(e);
      } else {
        toast.error("Please Fill All Fields");
      }
    }

    if (activeStep + 1 < allQuestions.length) {
      if (handleValidation()) {
        handleNext();
        window.scrollTo(0, 0);
      }
    }
  };

  //   onChange Handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  return (
    <>
      <title>Add Quiz</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-5 d-flex justify-content-between">
                <h4 className="Title">
                  <Link to={-1}>
                    <i className="fa fa-arrow-left"></i>
                  </Link>
                  Add Quiz
                </h4>
              </div>
            </div>

            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitHandler}>
                  <div className="sticky-stepper my-3">
                    <div className="mx-auto">
                      <Stepper orientation="horizontal" />
                    </div>
                  </div>
                  <div className="col-sm-12 col-form-label">
                    <label className="my-1">Quiz Date</label>
                    <span className="text-danger"> *</span>

                    <ReactDatePicker
                      selected={startDate}
                      onChange={(startDate) => {
                        setStartDate(startDate);
                      }}
                      className={`form-control ${
                        !startDate && errorField.startDate && "is-invalid"
                      }`}
                      showIcon
                      dateFormat="dd-MMM-yyyy"
                      placeholderText="dd-MMM-yyyy"
                      showMonthDropdown
                      useShortMonthInDropdown
                      showYearDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown
                      onChangeRaw={(e) => e.preventDefault()}
                    />
                    <div
                      className={`invalid-feedback ${
                        !startDate && errorField.startDate && "d-block"
                      }`}
                    >
                      {errorField.startDate}
                    </div>
                  </div>
                  <div className="form-group row mt-1">
                    <div className="col-sm-12">
                      {allQuestions &&
                        allQuestions.map((question, i) => {
                          return (
                            activeStep === i && (
                              <div
                                className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end my-2"
                                key={i}
                              >
                                <div className="row">
                                  <div className="col-sm-12 col-form-label">
                                    <TextEditor
                                      value={data[`question${i}`]}
                                      onChange={(value) =>
                                        setData({
                                          ...data,
                                          [`question${i}`]: value,
                                        })
                                      }
                                      label={"Question"}
                                      error={errorField[`question${i}`]}
                                      required
                                    />
                                  </div>

                                  {countArray(totalOption).map((num) => {
                                    return (
                                      <div
                                        className="col-sm-6 col-form-label"
                                        key={num}
                                      >
                                        <Input
                                          type="text"
                                          name={`option${COUNTS[num]}${i}`}
                                          value={
                                            data[`option${COUNTS[num]}${i}`] ||
                                            ""
                                          }
                                          onChange={onChangeHandler}
                                          placeholder={`Enter Option ${num}`}
                                          className={`form-control `}
                                          maxLength={500}
                                          label={`Option ${num}`}
                                          error={
                                            errorField[
                                              `option${COUNTS[num]}${i}`
                                            ]
                                          }
                                          required
                                        />
                                      </div>
                                    );
                                  })}

                                  <div className="col-sm-12 col-form-label">
                                    <Select
                                      name={`correctOption${i}`}
                                      placeholder="Select Correct Option"
                                      onChange={onChangeHandler}
                                      value={data[`correctOption${i}`] || ""}
                                      className={`form-control `}
                                      label={"Correct Option"}
                                      error={errorField[`correctOption${i}`]}
                                      required
                                    >
                                      <option value="">
                                        Select Correct Option
                                      </option>
                                      {alphabetsArray(totalOption).map(
                                        (data) => {
                                          return (
                                            <option value={data} key={data}>
                                              {data}
                                            </option>
                                          );
                                        }
                                      )}
                                    </Select>
                                  </div>

                                  <div className="col-sm-12 col-form-label">
                                    <TextEditor
                                      value={data[`answer${i}`]}
                                      onChange={(value) =>
                                        setData({
                                          ...data,
                                          [`answer${i}`]: value,
                                        })
                                      }
                                      label={"Answer"}
                                      error={errorField[`answer${i}`]}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            )
                          );
                        })}
                    </div>
                  </div>

                  {/* steps increment button */}
                  <div className="text-center mt-4">
                    <Button
                      type="button"
                      onClick={handleBack}
                      disabled={activeStep === 0}
                      className="mx-2"
                    >
                      Back
                    </Button>

                    <Button type="submit" {...submitButtonElement}>
                      {allStepsCompleted() ? "Add Quiz" : "Next"}
                    </Button>
                  </div>

                  {/* <div className="text-center mt-4">
                    <Button type="submit" {...submitButtonElement}>
                      Add Question
                    </Button>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddQuiz;
